import React from 'react';
import { Eye, EyeOff, Mail, Lock } from "lucide-react";

const LoginForm = ({ 
  username, setUsername, 
  password, setPassword, 
  showPassword, setShowPassword, 
  loading, errors, handleLogin 
}) => {
  return (
    <div className="bg-white/95 backdrop-blur-2xl rounded-[2rem] shadow-2xl border border-white/30 p-10">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-black text-slate-800 mb-3">Welcome</h2>
        <p className="text-slate-600 text-lg">Access your healthcare portal</p>
      </div>

      <div className="space-y-8">
        <div className="space-y-3">
          <label className="flex items-center space-x-2 text-slate-700 font-bold text-sm">
            <Mail className="h-4 w-4" />
            <span>Username or email address</span>
          </label>
          <input
            type="text"
            placeholder="Enter your username or email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={`w-full h-16 px-6 text-lg bg-slate-50 border-2 rounded-2xl focus:ring-4 focus:ring-teal-100 focus:outline-none transition-all duration-300 text-slate-800 placeholder-slate-400 hover:border-slate-300 ${errors.username ? 'border-red-500 focus:border-red-500' : 'border-slate-200 focus:border-teal-500'}`}
            disabled={loading}
          />
          {errors.username && (
            <p className="text-red-500 text-sm mt-1">{errors.username}</p>
          )}
        </div>

        <div className="space-y-3">
          <label className="flex items-center space-x-2 text-slate-700 font-bold text-sm">
            <Lock className="h-4 w-4" />
            <span>Password</span>
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full h-16 px-6 pr-16 text-lg bg-slate-50 border-2 rounded-2xl focus:ring-4 focus:ring-teal-100 focus:outline-none transition-all duration-300 text-slate-800 placeholder-slate-400 hover:border-slate-300 ${errors.password ? 'border-red-500 focus:border-red-500' : 'border-slate-200 focus:border-teal-500'}`}
              disabled={loading}
              onKeyDown={(e) => e.key === 'Enter' && handleLogin(e)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-5 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-teal-600 transition-colors p-2"
              disabled={loading}
            >
              {showPassword ? <EyeOff className="h-6 w-6" /> : <Eye className="h-6 w-6" />}
            </button>
          </div>
          {errors.password && (
            <p className="text-red-500 text-sm mt-1">{errors.password}</p>
          )}
          <div className="text-right">
            <a
              href="/forgot_password"
              className="text-sm text-teal-600 hover:text-teal-800 font-semibold transition-colors"
            >
              Forgot your password?
            </a>
          </div>
        </div>

        <button
          onClick={handleLogin}
          className="w-full h-16 bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-500 hover:from-teal-700 hover:via-teal-600 hover:to-cyan-600 text-white font-bold text-xl rounded-2xl shadow-2xl hover:shadow-teal-500/25 transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center space-x-3">
              <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Signing you in...</span>
            </div>
          ) : (
            'Sign In to Healthcare Portal'
          )}
        </button>
      </div>

      <div className="mt-10 pt-8 border-t border-slate-200 text-center">
        <p className="text-sm text-slate-500">
          Secure Healthcare Portal &copy; 2025 Surgix
        </p>
      </div>
    </div>
  );
};

export default LoginForm;
